import { useLocation } from "wouter";
import { initiateGoogleOAuthFlow } from "@/lib/oauth";

function useConnectWithGoogle() {
  const [location] = useLocation();

  const connectWithGoogle = async () => {
    const VITE_X_REDIRECT_URI = import.meta.env.VITE_X_REDIRECT_URI;
    const redirectUri = `${VITE_X_REDIRECT_URI}/oauth/callback`;
    await initiateGoogleOAuthFlow(redirectUri, location);
  };

  return {
    connectWithGoogle,
  };
}

export default useConnectWithGoogle;
